import React from "react";

export default function FormBoxIndex({ children }) {
  return (
    <div className="form-container">
      <div className={`text-center`}>
        <div className="desc-card mt-4">
          <div className="card-body col-sm-12 text-label-left p-5 selector-padding-left-right">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
